import React from 'react'
import TextField from '@mui/material/TextField'
import InputAdornment from '@mui/material/InputAdornment'
import SearchIcon from '@mui/icons-material/Search'
import ClearIcon from '@mui/icons-material/Clear'
import IconButton from '@mui/material/IconButton'
import { debounce } from 'lodash'
import { useTranslation } from 'react-i18next'

import { DEBOUNCE_SEARCH_TIME_LIMIT } from 'lib/participants/Constants'
import { ParticpantsContext } from 'containers/Participants'

// This component has debounce feature by default to avoid unnecessary API calls as user types in search field
// Using state will cause a re-rendering of component, which will make an API call on press of every key,
// To avoid that we are using ref, which will keep the debounce functionality intact

const Search = () => {
  const { onSearch } = React.useContext(ParticpantsContext).functions
  const { state } = React.useContext(ParticpantsContext)
  const { searchInputRef, clearable } = state
  const debounceSearch = debounce((eventData) => {
    onSearch(eventData)
  }, DEBOUNCE_SEARCH_TIME_LIMIT)

  const onClear = () => {
    searchInputRef.current.value = ''
    onSearch()
  }

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    debounceSearch(e.target.value)
  }

  const { t } = useTranslation()
  return (
    <TextField
      id="search-component"
      data-cy="search_component"
      data-testid="search-component"
      variant="standard"
      placeholder={t('participant.search.placeholder')}
      sx={{
        width: {
          xs: '100%',
          sm: '22rem',
        },
        float: 'right',
      }}
      inputRef={searchInputRef}
      type="text"
      onChange={handleChange}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon />
          </InputAdornment>
        ),
        endAdornment: (
          <InputAdornment position="start">
            {clearable ? (
              <IconButton edge="end" onClick={onClear}>
                <ClearIcon id="clear-search" />
              </IconButton>
            ) : (
              <></>
            )}
          </InputAdornment>
        ),
      }}
    />
  )
}

export default Search
